import { atom } from 'recoil'

export const isPrintingServiceOrderDetailState = atom({
  key: 'isPrintingServiceOrderDetailState',
  default: false
})
